<template>
    <div class="container">
        <div class="toolbar shadow-sm">
            <img src="@/assets/icons/ConfigurationIcon.png" />
            <span class="title">{{ $t("admin.system.map_deployment_tool.title") }}</span>
            <span>{{ titleExtra }}</span>
        </div>

        <div class="map-deployment-tool-container shadow-sm" ref="toolContainer">
            <a href="#" v-if="publishers == null" v-on:click="$event => handlePublishersClicked()">{{ $t("admin.system.map_deployment_tool.publishers_link") }}</a>
            <a href="#" v-if="publishers != null || selectedPublisher != null" v-on:click="$event => handleBackClicked()">{{ $t("admin.system.map_deployment_tool.back_link") }}</a>

            <ul v-if="publishers != null && selectedPublisher == null">
                <li v-for="publisher of publishers" v-bind:key="publisher.id">
                    <a href="#" v-on:click="handlePublisherSelected(publisher)">{{ publisherName(publisher) }}</a>
                </li>
            </ul>

            <ul v-if="selectedPublisherMapBundles != null && selectedPublisherMapBundles.length > 0 && selectedMapBundle == null">
                <li v-for="mapBundle of selectedPublisherMapBundles" v-bind:key="mapBundle.id">
                    <a href="#" v-on:click="handleMapBundleSelected(mapBundle)">{{ mapBundleTitle(mapBundle) }}</a>
                </li>
            </ul>

            <div v-if="selectedMapBundle != null">
                <p>
                    {{ $t("admin.system.map_deployment_tool.magic_link") }}: <a target="_blank" v-bind:href="mapBundleMagicLink(selectedMapBundle)">{{ mapBundleMagicLink(selectedMapBundle) }}</a>
                </p>
                
                <!-- <h3>Maps contained in the bundle</h3>
                <ul>
                    <li>TODO...</li>
                </ul> -->

                <div class="mb-3">
                    <label for="application_select" class="form-label">{{ $t("admin.system.map_deployment_tool.applications") }}</label>
                    <select type="text" class="form-control" id="application_select" v-model="selectedMapBundle.applicationId">
                        <option v-for="application of applications" v-bind:key="application.id" v-bind:value="application.id">{{ applicationName(application) }}</option>
                    </select>
                </div>

                <!-- <div class="mb-3">
                    <label for="mapBundleId_input" class="form-label">{{ $t("admin.system.map_deployment_tool.unique_identifier") }}</label>
                    <input type="text" class="form-control" id="mapBundleId_input" v-model="selectedMapBundle.id" />
                </div> -->

                <h3>{{ $t("admin.system.map_deployment_tool.catalog_information") }}</h3>

                <div class="mb-3">
                    <label for="title_en_input" class="form-label">{{ $t("admin.system.map_deployment_tool.title_en") }}</label>
                    <input type="text" class="form-control" id="title_en_input" v-model="selectedMapBundleTitle['en']" />
                </div>

                <div class="mb-3">
                    <label for="title_fr_input" class="form-label">{{ $t("admin.system.map_deployment_tool.title_fr") }}</label>
                    <input type="text" class="form-control" id="title_fr_input" v-model="selectedMapBundleTitle['fr']" />
                </div>

                <div class="mb-3">
                    <label for="description_en_input" class="form-label">{{ $t("admin.system.map_deployment_tool.description_en") }}</label>
                    <textarea type="text" class="form-control" id="description_en_input" v-model="selectedMapBundleDescription['en']" />
                </div>

                <div class="mb-3">
                    <label for="description_fr_input" class="form-label">{{ $t("admin.system.map_deployment_tool.description_fr") }}</label>
                    <textarea type="text" class="form-control" id="description_fr_input" v-model="selectedMapBundleDescription['fr']" />
                </div>

                <div class="mb-3">
                    <label for="publisherName_en_input" class="form-label">{{ $t("admin.system.map_deployment_tool.publisher_name_en_input") }}</label>
                    <input type="text" class="form-control" id="publisherName_en_input" v-model="selectedMapBundlePublisherName['en']" />
                </div>
                <div class="mb-3">
                    <label for="publisherName_fr_input" class="form-label">{{ $t("admin.system.map_deployment_tool.publisher_name_fr_input") }}</label>
                    <input type="text" class="form-control" id="publisherName_fr_input" v-model="selectedMapBundlePublisherName['fr']" />
                </div>
                <div class="mb-3">
                    <label for="publisherContact_input" class="form-label">{{ $t("admin.system.map_deployment_tool.publisher_contact_email_input") }}</label>
                    <input type="text" class="form-control" id="publisherContact_input" v-model="selectedMapBundle.publisherContact" />
                </div>
                <div class="mb-3">
                    <label for="publisherContactPhone_input" class="form-label">{{ $t("admin.system.map_deployment_tool.publisher_contact_phone_input") }}</label>
                    <input type="text" class="form-control" id="publisherContactPhone_input" v-model="selectedMapBundle.publisherContactPhone" />
                </div>
                <!--<div class="mb-3">
                    <label for="numberOfKilometers_input" class="form-label">{{ $t("admin.system.map_deployment_tool.number_of_kilometers_of_trails_input") }}</label>
                    <input type="text" class="form-control" id="numberOfKilometers_input" v-model="selectedMapBundle.numberOfKilometers" />
                </div>-->
                <div class="mb-3">
                    <label for="location_country_select" class="form-label">{{ $t("admin.system.map_deployment_tool.location_select") }}</label>
                    <select type="text" class="form-control" id="location_country_select" v-model="selectedMapBundleCountryId">
                        <option v-for="country of countries" v-bind:key="country.id" v-bind:value="country.id">{{ countryName(country) }}</option>
                    </select>
                    <select type="text" class="form-control" id="location_state_select" v-if="selectedCountry != null" v-model="selectedMapBundleStateId">
                        <option v-for="state of selectedCountry.states" v-bind:key="state.id" v-bind:value="state.id">{{ stateName(state) }}</option>
                    </select>
                    <select type="text" class="form-control" id="location_state_select" v-if="selectedState != null" v-model="selectedMapBundleRegionId">
                        <option v-for="region of selectedState.regions" v-bind:key="region.id" v-bind:value="region.id">{{ regionName(region) }}</option>
                    </select>
                </div>

                <div class="mb-3">
                    <label for="accessCodes_input" class="form-label">{{ $t("admin.system.map_deployment_tool.access_code") }}</label>
                    <input type="text" class="form-control" id="accessCodes_input" v-model="selectedMapBundle.mainAccessCode" />
                </div>

                <h3>{{ $t("admin.system.map_deployment_tool.center_point") }}</h3>
                <div class="mb-3">
                    <label for="centerPointLatitude_input" class="form-label">{{ $t("admin.system.map_deployment_tool.latitude") }}</label>
                    <input type="text" class="form-control" id="centerPointLatitude_input" v-model="selectedMapBundleCenterPoint.latitude" />
                </div>
                <div class="mb-3">
                    <label for="centerPointLongitude_input" class="form-label">{{ $t("admin.system.map_deployment_tool.longitude") }}</label>
                    <input type="text" class="form-control" id="centerPointLongitude_input" v-model="selectedMapBundleCenterPoint.longitude" />
                </div>

                <h3>{{ $t("admin.system.map_deployment_tool.actions") }}</h3>
                <div class="mb-3 form-check">
                    <input type="checkbox" class="form-check-input" id="emergencyActionAvailableCheckbox" v-model="selectedMapBundle.emergencyActionAvailable">
                    <label class="form-check-label" for="emergencyActionAvailableCheckbox">{{ $t("admin.system.map_deployment_tool.emergency_action_available") }}</label>
                </div>
                <div class="mb-3 form-check">
                    <input type="checkbox" class="form-check-input" id="terrainReportActionAvailableCheckbox" v-model="selectedMapBundle.terrainReportActionAvailable">
                    <label class="form-check-label" for="terrainReportActionAvailableCheckbox">{{ $t("admin.system.map_deployment_tool.terrain_report_action_available") }}</label>
                </div>

                <h3>{{ $t("admin.system.map_deployment_tool.ui") }}</h3>
                <div class="mb-3">
                    <label for="map_object_list_mode_select" class="form-label">{{ $t("admin.system.map_deployment_tool.map_object_list_mode") }}</label>
                    <select type="text" class="form-control" id="map_object_list_mode_select" v-model="selectedMapBundle.mapObjectListMode">
                        <option value="default">{{ $t("admin.system.map_deployment_tool.map_object_list_mode_default") }}</option>
                        <option value="suggestions">{{ $t("admin.system.map_deployment_tool.map_object_list_mode_suggestions") }}</option>
                    </select>
                </div>
                <div class="mb-3 form-check">
                    <input type="checkbox" class="form-check-input" id="useNewMapUICheckbox" v-model="selectedMapBundle.useNewMapUI">
                    <label class="form-check-label" for="useNewMapUICheckbox">{{ $t("admin.system.map_deployment_tool.use_new_map_ui") }}</label>
                </div>

<!--                <h3>{{ $t("admin.system.map_deployment_tool.files_upload") }}</h3>
                <div class="mb-3 form-check">
                    <input type="checkbox" class="form-check-input" id="supportPartialCheckbox" v-model="selectedMapBundle.supportPartialUpdate">
                    <label class="form-check-label" for="useNewMapUICheckbox">{{ $t("admin.system.map_deployment_tool.support_partial_update") }}</label>
                </div>

                <div>TODO Upload fields</div>-->

                <h3>{{ $t("admin.system.map_deployment_tool.catalog_sections") }}</h3>
                <div class="mb-3 form-check">
                    <input type="checkbox" class="form-check-input" id="accessibleCheckbox" v-model="selectedMapBundleAccessible">
                    <label class="form-check-label" for="accessibleCheckbox">{{ $t("admin.system.map_deployment_tool.accessible_checkbox") }}</label>
                </div>
                <div class="mb-3 form-check">
                    <label for="accessibleComment_en_input" class="form-label">{{ $t("admin.system.map_deployment_tool.accessible_comment_en") }}</label>
                    <input type="text" class="form-control" id="accessibleComment_en_input" v-model="selectedMapBundleAccessibleComment['en']" />
                </div>
                <div class="mb-3 form-check">
                    <label for="accessibleComment_fr_input" class="form-label">{{ $t("admin.system.map_deployment_tool.accessible_comment_fr") }}</label>
                    <input type="text" class="form-control" id="accessibleComment_fr_input" v-model="selectedMapBundleAccessibleComment['fr']" />
                </div>
                <div class="mb-3 form-check">
                    <input type="checkbox" class="form-check-input" id="dogsAllowedCheckbox" v-model="selectedMapBundleDogsAllowed">
                    <label class="form-check-label" for="dogsAllowedCheckbox">{{ $t("admin.system.map_deployment_tool.dogs_allowed_checkbox") }}</label>
                </div>
                <div class="mb-3 form-check">
                    <label for="dogsAllowedComment_en_input" class="form-label">{{ $t("admin.system.map_deployment_tool.dogs_allowed_comment_en") }}</label>
                    <input type="text" class="form-control" id="dogsAllowedComment_en_input" v-model="selectedMapBundleDogsAllowedComment['en']" />
                </div>
                <div class="mb-3 form-check">
                    <label for="dogsAllowedComment_fr_input" class="form-label">{{ $t("admin.system.map_deployment_tool.dogs_allowed_comment_fr") }}</label>
                    <input type="text" class="form-control" id="dogsAllowedComment_fr_input" v-model="selectedMapBundleDogsAllowedComment['fr']" />
                </div>
                <div class="mb-3 form-check">
                    <input type="checkbox" class="form-check-input" id="newMapsCheckbox" v-model="selectedMapBundleIncludedInNewMaps">
                    <label class="form-check-label" for="newMapsCheckbox">{{ $t("admin.system.map_deployment_tool.listed_in_new_maps_section") }}</label>
                </div>
                <div class="mb-3 form-check">
                    <input type="checkbox" class="form-check-input" id="ourSuggestionsCheckbox" v-model="selectedMapBundleIncludedInOurSuggestions">
                    <label class="form-check-label" for="ourSuggestionsCheckbox">{{ $t("admin.system.map_deployment_tool.listed_in_our_suggestions_section") }}</label>
                </div>
                <!--<h5>{{ $t("admin.system.map_deployment_tool.catalog_sections_activities") }}</h5>
                <div class="catalog-section-grid" v-if="legacySections != null">
                    <div class="mb-3 form-check" v-for="legacySection of legacySections" v-bind:key="legacySection.uniqueIdentifier">
                        <input type="checkbox" class="form-check-input" v-bind:id="legacySectionCheckboxId(legacySection)">
                        <label class="form-check-label" v-bind:for="legacySectionCheckboxId(legacySection)">{{ legacySectionName(legacySection) }}</label>
                    </div>
                </div>-->

                <button type="button" class="btn btn-primary" v-on:click="handleSaveClicked()">{{ $t("admin.system.map_deployment_tool.save_button") }}</button>
            </div>
        </div>
    </div>
</template>

<script>
import PublisherService from "@/service/PublisherService.js";
import ApplicationService from "@/service/ApplicationService.js";
import CatalogService from "@/service/CatalogService.js";
import LocationService from "@/service/LocationService.js";
import LangUtils from "@/utils/LangUtils.js";
import { resolve } from "path";
    
export default {    
    data() {
        return {
            publisherService: new PublisherService(),
            applicationService: new ApplicationService(),
            catalogService: new CatalogService(),
            locationService: new LocationService(),
            titleExtra: null,
            publishers: null,
            applications: null,
            legacySections: null,
            countries: null,
            selectedCountry: null,
            selectedState: null,
            selectedPublisher: null,
            selectedPublisherMapBundles: null,
            selectedMapBundle: null,
            selectedMapBundleTitle: {},
            selectedMapBundleDescription: {},
            selectedMapBundleCenterPoint: {},
            selectedMapBundlePublisherName: {},
            selectedMapBundleCountryId: null,
            selectedMapBundleStateId: null,
            selectedMapBundleRegionId: null,
            selectedMapBundleIncludedInNewMaps: false,
            selectedMapBundleIncludedInOurSuggestions: false,
            selectedMapBundleDogsAllowed: false,
            selectedMapBundleDogsAllowedComment: {},
            selectedMapBundleAccessible: false,
            selectedMapBundleAccessibleComment: {}
        }
    },

    watch: {
        publishers: function() {
            if (this.publishers) {
                this.titleExtra = this.$t("admin.system.map_deployment_tool.publishers_link");
            } else {
                this.titleExtra = null;
            }
        },

        selectedPublisher: function() {
            if (this.selectedPublisher != null) {
                this.titleExtra = this.titleExtra + " - " + this.publisherName(this.selectedPublisher);
                this._loadMapBundlesForPublisher(this.selectedPublisher.getId());
            } else {
                this.selectedPublisherMapBundles = null;
                this.titleExtra = this.$t("admin.system.map_deployment_tool.publishers_link");
            }

            this.$refs.toolContainer.scrollTop = 0;
        },

        selectedMapBundle: function() {
            if (this.selectedMapBundle) {
                var title = LangUtils.valueForLanguage(this.selectedMapBundle.getTitle(), this.$i18n);
                if (title == null) {
                    title = this.selectedMapBundle.getId();
                }
                this.titleExtra = this.titleExtra + " - " + title;

                this.selectedMapBundleTitle = this.selectedMapBundle.title ? this.selectedMapBundle.title : {};
                this.selectedMapBundleDescription = this.selectedMapBundle.description ? this.selectedMapBundle.description : {};
                this.selectedMapBundleCenterPoint = this.selectedMapBundle.centerPoint ? this.selectedMapBundle.centerPoint : {};
                this.selectedMapBundlePublisherName = this.selectedMapBundle.publisherName ? this.selectedMapBundle.publisherName : {};

                this.selectedMapBundleIncludedInNewMaps = this.selectedMapBundle.tags ? this.selectedMapBundle.tags["newMaps"] : false;
                this.selectedMapBundleIncludedInOurSuggestions = this.selectedMapBundle.tags ? this.selectedMapBundle.tags["ourSuggestions"] : false;

                this.selectedMapBundleCountryId = this.selectedMapBundle.location && this.selectedMapBundle.location.country ? this.selectedMapBundle.location.country : null;
                this.selectedMapBundleStateId = this.selectedMapBundle.location && this.selectedMapBundle.location.state ? this.selectedMapBundle.location.state : null;
                this.selectedMapBundleRegionId = this.selectedMapBundle.location && this.selectedMapBundle.location.region ? this.selectedMapBundle.location.region : null;

                this.selectedMapBundleDogsAllowed = this.selectedMapBundle.filterFields && this.selectedMapBundle.filterFields.dogsAllowed ? this.selectedMapBundle.filterFields.dogsAllowed : false;
                this.selectedMapBundleDogsAllowedComment = this.selectedMapBundle.dogsAllowedComment ? this.selectedMapBundle.dogsAllowedComment : {};
                this.selectedMapBundleAccessible = this.selectedMapBundle.filterFields && this.selectedMapBundle.filterFields.accessible ? this.selectedMapBundle.filterFields.accessible : false;
                this.selectedMapBundleAccessibleComment = this.selectedMapBundle.accessibleComment ? this.selectedMapBundle.accessibleComment : {};
            } else {
                this.titleExtra = this.$t("admin.system.map_deployment_tool.publishers_link") + " - " + this.publisherName(this.selectedPublisher);
            }

            this.$refs.toolContainer.scrollTop = 0;
        },

        selectedMapBundleTitle: function() {
            if (this.selectedMapBundle) {
                this.selectedMapBundle.title = this.selectedMapBundleTitle;
            }
        },

        selectedMapBundleDescription: function() {
            if (this.selectedMapBundle) {
                this.selectedMapBundle.description = this.selectedMapBundleDescription;
            }
        },

        selectedMapBundleCenterPoint: function() {
            if (this.selectedMapBundle) {
                this.selectedMapBundle.centerPoint = this.selectedMapBundleCenterPoint;
            }
        },

        selectedMapBundlePublisherName: function() {
            if (this.selectedMapBundle) {
                this.selectedMapBundle.publisherName = this.selectedMapBundlePublisherName;
            }
        },

        selectedMapBundleDogsAllowedComment: function() {
            if (this.selectedMapBundle) {
                this.selectedMapBundle.dogsAllowedComment = this.selectedMapBundleDogsAllowedComment;
            }
        },

        selectedMapBundleAccessibleComment: function() {
            if (this.selectedMapBundle) {
                this.selectedMapBundle.accessibleComment = this.selectedMapBundleAccessibleComment;
            }
        },
        
        selectedMapBundleCountryId: function() {
            for (var country of this.countries) {
                if (country.id == this.selectedMapBundleCountryId) {
                    this.selectedCountry = country;
                    break;
                }
            }

            this._updateSelectedMapBundleLocation();
        },

        selectedMapBundleStateId: function() {
            for (var state of this.selectedCountry.states) {
                if (state.id == this.selectedMapBundleStateId) {
                    this.selectedState = state;
                    break;
                }
            }

            this._updateSelectedMapBundleLocation();
        },

        selectedMapBundleRegionId: function() {
            this._updateSelectedMapBundleLocation();
        },

        selectedMapBundleIncludedInNewMaps: function() {
            this._updateSelectedMapBundleTags();
        },

        selectedMapBundleIncludedInOurSuggestions: function() {
            this._updateSelectedMapBundleTags();
        },

        selectedMapBundleDogsAllowed: function() {
            this._updateSelectedMapBundleFilterFields();
        },

        selectedMapBundleAccessible: function() {
            this._updateSelectedMapBundleFilterFields();
        }
    },

    methods: {
        publisherName(publisher) {
            const name = LangUtils.valueForLanguage(publisher.getName(), this.$i18n.locale);
            if (name) {
                return name;
            } else {
                return publisher.getId();
            }
        },

        mapBundleTitle(mapBundle) {
            const title = LangUtils.valueForLanguage(mapBundle.getTitle(), this.$i18n.locale);
            if (title) {
                return title + " (" + mapBundle.getId() + ")";
            } else {
                return mapBundle.getId();
            }
        },

        mapBundleMagicLink(mapBundle) {
            return "https://www.igloocreations.com/ondago/app/bundles/" + mapBundle.getId();
        },

        applicationName(application) {
            var name = LangUtils.valueForLanguage(application.getName(), this.$i18n.locale);
            if (name == null) {
                name = application.getId();
            }

            return name;
        },

        legacySectionCheckboxId(legacySection) {
            return legacySection.uniqueIdentifier + "Checkbox";
        },

        legacySectionName(legacySection) {
            return LangUtils.valueForLanguage(legacySection, this.$i18n.locale);
        },

        countryName(country) {
            return LangUtils.valueForLanguage(country.name, this.$i18n.locale);
        },
        
        stateName(state) {
            return LangUtils.valueForLanguage(state.name, this.$i18n.locale);
        },

        regionName(region) {
            return LangUtils.valueForLanguage(region.name, this.$i18n.locale);
        },  

        handleBackClicked() {
            if (this.selectedMapBundle) {
                this.selectedMapBundle = null;
            } else if (this.selectedPublisher) {
                this.selectedPublisher = null;
            } else if (this.publishers) {
                this.publishers = null;
            }
        },

        handlePublishersClicked() {
            this._loadAllPublishers();
        },

        handlePublisherSelected(publisher) {
            this.selectedPublisher = publisher;
        },  

        handleMapBundleSelected(mapBundle) {
            this.selectedMapBundle = mapBundle;
        },

        handleSaveClicked() {
            this._saveMapBundle();
        },

        _loadAllPublishers() {
            this.publisherService.loadPublishers().then((publishers) => {
                if (publishers) {
                    // Temporary measure. Removing publishers who do not have bundles published yet.
                    // When the migration is coompleted, this scoping out code will be removed.
                    const publishersToUse = this._scopeOutUnwantedPublishers(publishers);

                    publishersToUse.sort((publisher1, publisher2) => {
                        var publisher1Title = LangUtils.valueForLanguage(publisher1.getName(), this.$i18n.locale);
                        var publisher2Title = LangUtils.valueForLanguage(publisher2.getName(), this.$i18n.locale);
                        
                        if (publisher1Title == null) {
                            publisher1Title = publisher1.id;
                        }
                        if (publisher2Title == null) {
                            publisher2Title = publisher2.id;
                        }

                        return publisher1Title.localeCompare(publisher2Title);
                    });

                    this.publishers = publishersToUse;
                }
            }).catch((error) => {
                // TODO handle error
                console.log(error.message);
            });
        },

        _scopeOutUnwantedPublishers(publishers) {
            const result = []

            for (var publisher of publishers) {
                if (publisher.id == "ondago" || publisher.id == "TrakMaps") {
                    result.push(publisher);
                }
            }

            return result;
        },

        _loadMapBundlesForPublisher(publisherId) {
            this.publisherService.loadPublisherMapBundles(publisherId).then((mapBundles) => {
                if (mapBundles) {
                    mapBundles.sort((mapBundle1, mapBundle2) => {
                        var mapBundle1Title = LangUtils.valueForLanguage(mapBundle1.getTitle(), this.$i18n.locale);
                        var mapBundle2Title = LangUtils.valueForLanguage(mapBundle2.getTitle(), this.$i18n.locale);

                        if (mapBundle1Title == null) {
                            mapBundle1Title = mapBundle1.getId();
                        }
                        if (mapBundle2Title == null) {
                            mapBundle2Title = mapBundle2.getId();
                        }

                        return mapBundle1Title.localeCompare(mapBundle2Title);
                    });
                    this.selectedPublisherMapBundles = mapBundles;
                }
            }).catch((error) => {
                // TODO handle error
                console.log(error.message);
            });
        },

        _updateSelectedMapBundleLocation() {
            const location = {
                country: this.selectedMapBundleCountryId,
                state: this.selectedMapBundleStateId,
                region: this.selectedMapBundleRegionId
            }

            if (this.selectedMapBundleCountryId) {
                var foundCountry = null;
                for (var country of this.countries) {
                    if (country.id == this.selectedMapBundleCountryId) {
                        foundCountry = country;
                        break;
                    }
                }

                if (foundCountry && this.selectedMapBundleStateId) {
                    var foundState = null;
                    for (var state of foundCountry.states) {
                        if (state.id == this.selectedMapBundleStateId) {
                            foundState = state;
                            break;
                        }
                    }

                    if (foundState == null) {
                        location.state = null;
                        location.region = null;
                        this.selectedMapBundleRegionId = null;
                        this.selectedMapBundleStateId = null;
                    } else if (this.selectedMapBundleRegionId) {
                        var foundRegion = null;
                        for (var region of foundState.regions) {
                            if (region.id == this.selectedMapBundleRegionId) {
                                foundRegion = region;
                                break;
                            }
                        }

                        if (foundRegion == null) {
                            location.region = null;
                            this.selectedMapBundleRegionId = null;
                        }
                    }
                }
            }

            if (this.selectedMapBundle) {
                this.selectedMapBundle.location = location;
            }
        },

        _updateSelectedMapBundleTags() {
            var tags = this.selectedMapBundle.tags;
            
            if (!tags) {
                tags = {};
            }

            tags["newMaps"] = this.selectedMapBundleIncludedInNewMaps;
            tags["ourSuggestions"] = this.selectedMapBundleIncludedInOurSuggestions;

            this.selectedMapBundle.tags = tags;
        },

        _updateSelectedMapBundleFilterFields() {
            const filterFields = {
                dogsAllowed: this.selectedMapBundleDogsAllowed,
                accessible: this.selectedMapBundleAccessible
            };

            this.selectedMapBundle.filterFields = filterFields;
        },

        _saveMapBundle() {
            this.publisherService.saveBundleForPublisher(this.selectedPublisher.id, this.selectedMapBundle).then(() => {
                this.handleBackClicked();
                resolve();
            }).catch((error) => {
                // TODO handle error
                console.log(error.message);
            });
        }
    },

    mounted() {
        this.applicationService.loadApplications().then((applications) => {
            this.applications = applications;
        }).catch((error) => {
            // TODO manage error
            console.log(error.message);
        });

        this.locationService.loadCountries().then((countries) => {
            countries.sort((country1, country2) => {
                const country1Name = LangUtils.valueForLanguage(country1.name, this.$i18n.locale);
                const country2Name = LangUtils.valueForLanguage(country2.name, this.$i18n.locale);
                return country1Name.localeCompare(country2Name);
            });

            for (const country of countries) {
                if (country.states) {
                    country.states.sort((state1, state2) => {
                        const state1Name = LangUtils.valueForLanguage(state1.name, this.$i18n.locale);
                        const state2Name = LangUtils.valueForLanguage(state2.name, this.$i18n.locale);
                        return state1Name.localeCompare(state2Name);
                    });

                    for (const state of country.states) {
                        if (state.regions) {
                            state.regions.sort((region1, region2) => {
                                const region1Name = LangUtils.valueForLanguage(region1.name, this.$i18n.locale);
                                const region2Name = LangUtils.valueForLanguage(region2.name, this.$i18n.locale);
                                return region1Name.localeCompare(region2Name);
                            })
                        }
                    }
                }
            }

            this.countries = countries;
        }).catch((error) => {
            // TODO manager error
            console.log(error.message);
        });

        this.catalogService.loadLegacySections().then((sections) => {
            this.legacySections = sections;
        }).catch((error) => {
            // TODO manage error
            console.log(error.message);
        });
    }
}
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
    margin: 0px;
    margin-bottom: 16px;
    width: 100%;
    max-width: none;
    text-align: left;
}

.toolbar {
    background-color: #ffffff;
    margin-bottom: 8px;
    padding: 8px;
    padding-left: 24px;
    text-align: left;
    width: 100%;
}

.toolbar img {
    margin-right: 16px;
    width: 50px;
}

.toolbar .title {
    display: inline-block;
    font-size: 16px;
    font-weight: bold;
    margin-right: 36px;
    max-width: 250px;
}

.toolbar button {
    margin: 0px 4px;
}

.map-deployment-tool-container {
    background-color: #ffffff;
    margin: 0 auto;
    overflow: scroll;
    padding: 24px;
    text-align: left;
    width: 100%;
    height: 100%;
}

.catalog-section-grid {
    display: grid;
    grid-template-columns: auto auto auto auto;
}
</style>